import { createFileRoute, isRedirect, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { LoginPage } from '@/features/auth/LoginPage';
import { safeRedirect, sessionQuery } from '@/features/auth/session';

const loginSearch = z.object({
    /** Where to go once signed in; only same-origin paths are honoured. */
    redirect: z.string().optional(),
    /**
     * 1.6: the person is here because their session ended, not by choice; `idle` when the idle
     * limit ran out (ALS-494), `changed` when their account did (ALS-525).
     */
    reason: z.enum(['expired', 'idle', 'changed']).optional(),
    /** With the idle reason: the limit that ran out, in minutes, as the server set it (ALS-494). */
    minutes: z.coerce.number().int().positive().optional(),
});

export const Route = createFileRoute('/login')({
    validateSearch: (search) => loginSearch.parse(search),
    // Someone who still has a session does not need the form: straight through.
    beforeLoad: async ({ context, search }) => {
        try {
            await context.queryClient.ensureQueryData(sessionQuery);
        } catch (error) {
            if (isRedirect(error)) throw error;
            return;
        }
        throw redirect({ href: safeRedirect(search.redirect) });
    },
    component: LoginPage,
});
